import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'typewriter',
	templateUrl: './typewriter.component.html',
	styleUrls: ['./typewriter.component.scss'],
	standalone: false,
})
export class TypewriterComponent implements OnInit {
	@Input() fullText: string;
	displayedText: string = '';
	private typingSpeed: number = 5;

	ngOnInit(): void {
		this.startTyping();
	}

	startTyping(): void {
		let currentIndex = 0;
		const interval = setInterval(() => {
			if (currentIndex < this.fullText.length) {
				this.displayedText += this.fullText[currentIndex];
				currentIndex++;
			} else {
				clearInterval(interval);
			}
		}, this.typingSpeed);
	}
}
